var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldEmojiNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0ADE6FA2-7547-4233-BEB9-CFECF1DDB7A8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-492.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-normal",
    transform: "translate(492.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80999994,2 C4.16999984,2 2,4.16999984 2,7.80999994 L2,16.1800003 C2,19.8300004 4.16999984,22 7.80999994,22 L16.1800003,22 C19.8200004,22 21.9900341,19.8300006 21.9900341,16.1900005 L21.9900341,7.80999994 C22,4.16999984 19.8300006,2 16.1900005,2 L7.80999994,2 Z M7.53000021,7.71999979 C8.24000019,8.42999977 9.39999968,8.42999977 10.1099997,7.71999979 C10.3999996,7.4299998 10.8800001,7.4299998 11.1700001,7.71999979 C11.4600001,8.00999978 11.4600001,8.48999974 11.1700001,8.77999973 C10.5200001,9.42999971 9.66999972,9.75 8.81999969,9.75 C7.96999967,9.75 7.11999977,9.42999971 6.46999979,8.77999973 C6.1799998,8.47999972 6.1799998,8.00999978 6.46999979,7.71999979 C6.75999978,7.4299998 7.24000022,7.4299998 7.53000021,7.71999979 Z M7.11999989,13.8999996 C7.11999989,13.1999996 7.69000036,12.6199999 8.39000034,12.6199999 L15.5900002,12.6199999 C16.2900001,12.6199999 16.8600006,13.1899996 16.8600006,13.8999996 C16.8800006,16.5899997 14.6900001,18.7800007 12,18.7800007 C9.30999994,18.7800007 7.11999989,16.5899997 7.11999989,13.8999996 Z M15.1800003,9.75 C14.3300003,9.75 13.4799999,9.42999971 12.8299999,8.77999973 C12.5399999,8.48999974 12.5399999,8.00999978 12.8299999,7.71999979 C13.1199999,7.4299998 13.6000004,7.4299998 13.8900003,7.71999979 C14.6000003,8.42999977 15.7599993,8.42999977 16.4699993,7.71999979 C16.7599993,7.4299998 17.2400007,7.4299998 17.5300007,7.71999979 C17.8200007,8.00999978 17.8200007,8.47999972 17.5300007,8.77999973 C16.8800007,9.42999971 16.0300003,9.75 15.1800003,9.75 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldEmojiNormal);
export default __webpack_public_path__ + "static/media/vuesax-bold-emoji-normal.8a9d7ecc07f455424428a440daa57341.svg";
export { ForwardRef as ReactComponent };